import React, {useEffect, useRef} from 'react';
import './WorkshopVideo.scss';
import {Page} from "../models/Page";

export const WorkshopVideo = (props: { page: Page, videoId: string }) => {

    const ref = useRef(null);

    // useEffect(() => {
        // let timerId = 0;
        // const f = () => {
            // timerId = window.requestAnimationFrame(f);
            // const e = ref.current;
            // if (!e) return;
            // if (props.page === Page.Video) return;
            // if (props.page === Page.Top) return;
            // if (!document.body.classList.contains('mobile')) return;
            // const e2 = e as HTMLIFrameElement;
            // const s = e2.style;
            // const wh = window.innerHeight;
            // const r = e2.getBoundingClientRect();
            // s.left = '5px';
            // s.top = (window.scrollY + wh - r.height - 5) + 'px';
        // };
        // f();
        // return () => {
            // cancelAnimationFrame(timerId);
        // };
    // }, [props.page]);

    if (props.page === Page.Top) return (<div/>);

    return (
        <div className={`workshop-video ${props.page}`}>
            <div className="workshop-video__youtube-wrapper">

                <iframe ref={ref}
                        src={"https://www.youtube.com/embed/" + props.videoId + "?autoplay=1&rel=0&playsinline=1&fs=0&iv_load_policy=3&modestbranding=1&showinfo=0"}
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        title={'video1'}></iframe>

            </div>

        </div>
    );
};